import { Component, Prop, Vue } from 'vue-property-decorator';

import { FEE_TYPE } from "@/constants/fee-type";
import { Fee } from '@/views/checkout/interfaces';
import { formatCurrency } from '@/core/currency/helpers';
import { CurrencyInfo, ExchangeRate } from '@/core/currency/interfaces';

@Component
export default class FeeInfo extends Vue {
    @Prop(Object)
    currency: CurrencyInfo;

    @Prop()
    formatPattern: string;

    @Prop({ type: Array, default: [] })
    fees: Array<Fee>;

    @Prop(Object)
    exchangeRate: ExchangeRate;

    get filteredFees() {
        return this.fees.filter((fee) => fee.type !== FEE_TYPE.Surcharge);
    }

    formatPrice(price) {
        return formatCurrency(
            (price / 100).toString(),
            this.currency.format,
            this.formatPattern
        );
    }

    joinFees(index: number, translation: string): string {
        let joinCharacter: string = '';

        if (index + 1 === this.fees.length - 1) {
            joinCharacter = translation;
        } else if (index + 1 < this.fees.length) {
            joinCharacter = ', ';
        }

        return joinCharacter;
    }

    exchangeRateFormatFees(price) {
        if (!this.exchangeRate) {
            return null;
        }

        return formatCurrency(
            ((price / 100) * this.exchangeRate?.rate).toFixed(2).toString(),
            this.currency.format,
            this.formatPattern
        );
    }
}
